/**
 * ExpandIcon — sanitized from `assets/newSvg/expand.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ExpandIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M8.93934,12.939275 C9.5251,12.353575 10.4749,12.353575 11.0607,12.939275 C11.6097937,13.4884625 11.6441121,14.3575719 11.1636551,14.9467496 L11.0607,15.060675 L7.12132,18.999975 L8.5,18.999975 C9.32843,18.999975 10,19.671575 10,20.499975 C10,21.2796456 9.40511446,21.9204207 8.64446046,21.9931082 L8.5,21.999975 L3.5,21.999975 C2.72030118,21.999975 2.079551,21.4050629 2.00686655,20.6444308 L2,20.499975 L2,15.499975 C2,14.671575 2.67157,13.999975 3.5,13.999975 C4.27969882,13.999975 4.920449,14.5948871 4.99313345,15.3555192 L5,15.499975 L5,16.878675 L8.93934,12.939275 Z M20.499975,2 C21.2796456,2 21.9204207,2.59488554 21.9931082,3.35553954 L21.999975,3.5 L21.999975,8.5 C21.999975,9.32843 21.328375,10 20.499975,10 C19.7203044,10 19.0795293,9.40511446 19.0068418,8.64446046 L18.999975,8.5 L18.999975,7.12132 L15.060675,11.0607 C14.474875,11.6464 13.525075,11.6464 12.939275,11.0607 C12.3901812,10.5115125 12.3558629,9.64240312 12.8363199,9.05325835 L12.939275,8.93934 L16.878675,5 L15.499975,5 C14.671575,5 13.999975,4.32843 13.999975,3.5 C13.999975,2.72030118 14.5948871,2.079551 15.3555192,2.00686655 L15.499975,2 L20.499975,2 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ExpandIcon;
